<div class="mini-cart-item-container">
  <div class="article-name">
    {{item.product.name}}
  </div>

  <div class="article-details">
    @if (item.product.manufacturerAID) {
      <div class="manufacturerAID">
        {{ item.product.manufacturerAID }}
        @if (item.product.manufacturer) {
          <span>&nbsp;/&nbsp;{{
          item.product.manufacturer }}</span>
        } @else {
          @if (item.product.manufacturerId) {
            <span>&nbsp;/&nbsp;{{ item.product.manufacturerId
            }}</span>
          }
        }
      </div>
    }

    @if (item.basePrice) {
      <div class="price">
        {{ item.basePrice?.formattedValue }}
      </div>
    }
  </div>

  <div class="mini-cart-item-actions">
    <app-efa-item-counter [control]="quantityControl" [readonly]="!item.updateable || readonly || item.parent"
      [allowZero]="true">
    </app-efa-item-counter>

    @if (!item.parent && item.updateable) {
      <div class="actions-delete">
        <cx-icon [type]="iconType.CLEAR" (click)="removeItem()" class="u-pointer"></cx-icon>
      </div>
    }
  </div>
</div>
